<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Withdrawal Same Name') }}</h3>
                <span class="fz-16 fw-400">Fill out the form to initiate a withdrawal</span>
            </div>

            <step-container :current_step="3" :step_list="stepList"></step-container>
        </div>

        <b-container fluid class="mt-0 pb-5">

            <b-row>
                <b-col cols="12" md="8" class="mx-auto">
                    <div id="body-container" v-if="remittance">
                        <div class="p-0 pb-5 text-center">
                            <img :src="`${publicPath}/img/gep/withdrawal-icon.svg`"
                                style="background-color: #EDF8F1;border-radius: 20px;">
                            <h5 class="my-3">Withdrawal Same Name</h5>
                            <hr />

                            <div class="d-flex mb-3">
                                <div>Payment Methods</div>
                                <div class="ml-auto fw-700">{{ remittance.paymentMode }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Amount</div>
                                <div class="ml-auto fw-700">{{ remittance.paymentCcy }} {{ (remittance.fixedModel ==
                                    1) ? getAmount(remittance.paymentAmount) : getAmount(remittance.payeeAmount) }}
                                </div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Payment Fee</div>
                                <div class="ml-auto fw-700">USD {{ getAmount(remittance.paymentFee) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Payment Fee Currency</div>
                                <div class="ml-auto fw-700">{{ remittance.paymentFeeCcy }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Company Account Name</div>
                                <div class="ml-auto fw-700">{{ remittance.accountName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Company Currency</div>
                                <div class="ml-auto fw-700">{{ remittance.payeeCcy }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Company Card Number</div>
                                <div class="ml-auto fw-700">{{ remittance.cardNo }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Payment Type</div>
                                <div class="ml-auto fw-700">{{ getType(remittance.fixedModel) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Purpose of Payment</div>
                                <div class="ml-auto fw-700">{{ getPurpose(remittance.paymentPurpose) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Payment Reference</div>
                                <div class="ml-auto fw-700">{{ remittance.paymentReference }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank charges to be borne</div>
                                <div class="ml-auto fw-700">{{ getCostBorne(remittance.costBorne) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Proof of Payment</div>
                                <div class="ml-auto fw-700">
                                    <a class="link" :download="'voucher.' + filetypePaymentMaterial"
                                        :href="encodePaymentMaterial">Download Voucher</a>
                                </div>
                            </div>

                            <hr />
                            <div class="d-flex mb-0">
                                <button @click="$router.go(-1);" class="btn btn-previous d-block mr-auto">{{
                                    $t('Previous') }}</button>
                                <button @click="$bvModal.show('modal-payment-password');"
                                    class="btn btn-primary d-block">{{ $t('Submit') }}</button>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>

        </b-container>

        <b-modal id="modal-payment-password" hide-footer hide-title>
            <PaymentPassword @on-submit="validatePin"></PaymentPassword>
        </b-modal>

        <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
</template>
<script>

import LoaderComponent from "@/components/LoaderComponent";
import stepContainer from "@/components/CardManagement/stepContainer";
import PaymentPassword from "@/components/PaymentPassword";
import Global from '@/services/Global';
import DB from '@/services/DB';
import Companies from "@/services/Companies";
import Common from "@/services/Common";
import CreateAccount from '@/services/CreateAccount';

export default {
    name: 'remittance-summary',
    data() {
        return {
            publicPath: process.env.BASE_URL != '/' ? process.env.BASE_URL : '',
            isLoading: false,
            remittance: null,
            maxSize: 4,
            paymentMaterial: '',
            transferId: '',
            encodePaymentMaterial: '',
            filetypePaymentMaterial: '',
            fixedModelList: {
                1: "Foreign Exchange Account",
                2: "Receiving Account"
            },
            paymentPurposeOpt: {
                1: "current settlement",
                2: "loan",
                3: "travel expenses",
                4: "living expenses",
                5: "investment funds",
                6: "office expenses",
                7: "engineering funds",
                8: "labor costs/salaries",
                9: "tuition fees",
                10: "others"
            },
            costBorneOpt: {
                "OUR": "OUR (sender pays all charges)",
                "SHA": "SHA (shared charges)"
            },
            paymentChannelTypeOpt: {
                "SWIFT": "SWIFT",
                "LOCAL": "LOCAL"
            },
            stepList: ["Select Withdrawal", "Fill Information", "Withdrawal Summary"],
        }
    },
    components: {
        LoaderComponent,
        stepContainer,
        PaymentPassword
    },
    methods: {
        validatePin(pin) {
            let self = this;
            this.isLoading = true;
            Common.validate_payment_password({
                "securitycode": pin.join(""),
            }).then(response => {
                if (response.status == 200) {
                    this.$bvModal.hide('modal-payment-password');
                    this.uploadProof();
                }
            }).catch(err => {
                self.isLoading = false;
                this.checkError(err);
            });
        },
        getCostBorne(type) {
            return this.costBorneOpt[type];
        },
        getPurpose(type) {
            return this.paymentPurposeOpt[parseInt(type)];
        },
        getAmount(amount) {
            return Global.addCommas(amount);
        },
        getMessage: function (key) {
            return this.$t(key)
        },
        getType(type) {
            return this.fixedModelList[parseInt(type)];
        },
        uploadProof() {
            let self = this;
            this.isLoading = true;
            if (this.paymentMaterial == '' || this.paymentMaterial == null) {
                CreateAccount.uploadFile({
                    "accountId": self.remittance.accountId,
                    "userNo": "" + self.remittance.userNo,
                    "fileUpload": [
                        {
                            "type": 23,
                            "maxSize": self.maxSize * 1024 * 1024,
                            "file": self.encodePaymentMaterial
                        }
                    ]
                }).then(response => {
                    const data = response.data.data;
                    let fileList = data["file"];
                    for (let i = 0; i < fileList.length; i++) {
                        if (fileList[i].type == 23) {
                            self.paymentMaterial = fileList[i].fileId;
                        }
                    }
                    self.doSubmit();
                }).catch(err => {
                    self.checkError(err);
                });
            }
            else {
                self.doSubmit();
            }
        },

        doSubmit() {
            let self = this;

            Companies.accountsTransfer({
                userNo: this.remittance.userNo, // userNo orang yang login
                payerAmt: this.remittance.paymentAmount == 0 ? this.remittance.payeeAmount : this.remittance.paymentAmount,
                payerCcy: this.remittance.paymentCcy,
                payeeUserNo: this.remittance.userNo_company_relation // userNo master company (BurgerKing)

            }).then((response) => {

                if (response.status == 200) {
                    self.isLoading = false;

                    let data = response.data.data;
                    let transferId = data.transferId;

                    console.log("Transfer ID:", transferId);

                    Companies.consolidationRequest({
                        userNo: this.remittance.userNo, // userNo yang login
                        partnerBankId: this.remittance.partnerBankId,
                        paymentMode: this.remittance.paymentMode,
                        paymentAmount: this.remittance.paymentAmount,
                        payeeAmount: this.remittance.payeeAmount,
                        fixedModel: parseInt(this.remittance.fixedModel),
                        paymentCcy: this.remittance.paymentCcy,
                        paymentPurpose: parseInt(this.remittance.paymentPurpose),
                        paymentReference: this.remittance.paymentReference,
                        costBorne: this.remittance.costBorne,
                        paymentFeeAmount: this.remittance.paymentFee,
                        paymentFeeCcy: this.remittance.paymentFeeCcy,
                        paymentMaterial: this.paymentMaterial,
                        accountCcy: this.remittance.payeeCcy,
                        approximate: "12345",
                        userNo_companyRelation: this.remittance.userNo_company_relation, // userNo company tujuan
                        transfer_id: transferId

                    }).then((response) => {
                        console.log(response);

                        if (response.status == 200) {
                            self.isLoading = false;
                            let data = response.data.data;
                            localStorage.removeItem("remittance-cp");
                            DB.delete("paymentMaterial_filetype").then(data => {
                                self.filetypePaymentMaterial = filetype;
                            });

                            DB.delete("paymentMaterial").then(data => {
                                self.$swal({
                                    icon: 'success',
                                    title: self.getMessage('Success'),
                                    showConfirmButton: true,
                                }).then((result) => {
                                    self.$router.push({
                                        path: '/consolidation',
                                    });
                                });
                            });

                        }
                    })
                        .catch((err) => {
                            console.log(err);
                            self.checkError(err);
                        });




                } else {
                    console.log(err);
                    self.checkError(err);
                }

            }).catch((error) => {
                console.log(err);
                self.checkError(err);
            });

        },


        checkError(err) {
            this.isLoading = false;
            const response = err.response;
            let self = this;

            if (response.status == 400 || response.status == 500) {
                try {
                    response.data.message = JSON.parse(response.data.message);
                }
                catch (e) {
                    console.log("");
                }

                if (typeof response.data.message === 'string') {
                    this.$swal({
                        icon: 'info',
                        html: response.data.message,
                        showConfirmButton: true,
                        confirmButtonText: self.getMessage('OK')
                    });
                }
                else {
                    if (response.data.message['errorMsg']) {
                        this.$swal({
                            icon: 'info',
                            html: response.data.message['errorMsg'],
                            showConfirmButton: true,
                            confirmButtonText: self.getMessage('OK')
                        });
                    }
                    else {
                        let ret = [];
                        Object.keys(response.data.message).forEach((key) => {
                            if (typeof response.data.message === 'string') {
                                ret.push(response.data.message[key][0]);
                            }
                            else {
                                ret.push(response.data.message[key][0]['message']);
                            }
                        });

                        this.$swal({
                            icon: 'info',
                            html: ret.join("<br>"),
                            showConfirmButton: true,
                            confirmButtonText: self.getMessage('OK')
                        });
                    }
                }
            }
            else if (response.status == 401 && response.data.name == "Unauthorized") {
                localStorage.removeItem("token");
                localStorage.removeItem("member");
                localStorage.removeItem("isFirstTime");
                this.$router.push({
                    path: '/login',
                });
            }
            else {
                if (localStorage.getItem("token")) {
                    var msg = (response.data) ? response.data.message : err.message;
                    this.$swal({
                        icon: 'info',
                        html: msg,
                        showConfirmButton: true,
                        confirmButtonText: self.getMessage('OK')
                    });
                }
            }
        }
    },
    mounted() {
        let self = this;
        const savedremittance = JSON.parse(localStorage.getItem('remittance-cp'));

        console.log(savedremittance)
        this.remittance = savedremittance;

        DB.get("paymentMaterial_filetype").then(filetype => {
            self.filetypePaymentMaterial = filetype;
        });

        DB.get("paymentMaterial").then(data => {
            self.encodePaymentMaterial = data;
        });
    }
};
</script>

<style scoped>
a.link {
    color: #6153d7 !important;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
}

ul li {
    list-style: disc;
}

.point .number {
    background-color: rgba(103, 163, 83, 1);
    border-radius: 50%;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    padding: 3px;
    font-weight: 500;
    color: #fff;
}

.account-type:hover {
    background: linear-gradient(90deg, #00AEEF 0%, #0972D3 100%) !important;
}

.block-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

hr {
    border-style: dashed;
}
</style>